function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { FeesByEnumDTO, PaymentMethodEnumDTO, PaymentProcessorTypeEnumDTO, RefundStatusTypeEnumDTO } from 'anchor-ts-infra/src/dto/payment/dto';
import Decimal from 'decimal.js';
export class PaymentModel {
  constructor(data) {
    this.data = data;
  }
  fees() {
    return this.data.fees;
  }
  paymentProcessorType() {
    return this.data.paymentProcessorType;
  }
  isPaymentProcessorColumn() {
    return this.data.paymentProcessorType === PaymentProcessorTypeEnumDTO.Column;
  }
  isPaymentProcessorStripe() {
    return this.data.paymentProcessorType === PaymentProcessorTypeEnumDTO.Stripe;
  }
  isFeesAch() {
    return this.data.fees.type === PaymentMethodEnumDTO.Ach;
  }
  isFeesCreditCard() {
    return this.data.fees.type === PaymentMethodEnumDTO.CreditCard;
  }
  creditCardFees() {
    return this.data.fees.type === PaymentMethodEnumDTO.CreditCard ? this.data.fees.creditCard : null;
  }
  isVendorFees() {
    return this.data.fees.type === PaymentMethodEnumDTO.CreditCard && this.data.fees.creditCard.feesBy === FeesByEnumDTO.Vendor;
  }
  isCustomerFees() {
    return this.data.fees.type === PaymentMethodEnumDTO.CreditCard && this.data.fees.creditCard.feesBy === FeesByEnumDTO.Customer;
  }
  remainingAmount() {
    const successfulRefunds = this.successfulRefunds() || [];
    return successfulRefunds.length > 0 ? new Decimal(successfulRefunds[successfulRefunds.length - 1].amounts.remainingAmount).div(100) : null;
  }
  refunds() {
    return this.data.refunds;
  }
  successfulRefunds() {
    return this.data.refunds && this.data.refunds.filter(r => [RefundStatusTypeEnumDTO.Refunded, RefundStatusTypeEnumDTO.Initiated].includes(r.refundStatus));
  }
  totalRefunded() {
    const successfulRefunds = this.successfulRefunds();
    return successfulRefunds ? successfulRefunds.reduce((acc, refund) => acc.add(new Decimal(refund.amounts.refundAmount).div(100)), new Decimal(0)).add(successfulRefunds.reduce((acc, refund) => acc.add(new Decimal(refund.amounts.refundFees).div(100)), new Decimal(0))).toFixed(2).replace(/\.00$/, '') : '0';
  }
  hasRefundFees() {
    const successfulRefunds = this.successfulRefunds() || [];
    return successfulRefunds.some(refund => refund.amounts.refundFees > 0);
  }
  addRefund(refund) {
    return new PaymentModel(_objectSpread(_objectSpread({}, this.data), {}, {
      refunds: [...(this.data.refunds || []), refund]
    }));
  }
}